import { AppStatus } from '@mcper/core';
import { api } from '../../services/api';
import type { AppSummary, HealthInfo, Organisation } from '../../types';

/** Component-level service for the shell (org name, degraded badge, logout). */
export const shellService = {
  loadOrg(): Promise<Organisation> {
    return api.get<Organisation>('/api/org');
  },
  async loadDegradedCount(): Promise<number> {
    const apps = await api.get<AppSummary[]>('/api/apps');
    return apps.filter((a) => a.status === AppStatus.Degraded).length;
  },
  health(): Promise<HealthInfo> {
    return api.get<HealthInfo>('/health');
  },
  logout(): Promise<void> {
    return api.post<void>('/auth/logout');
  },
};
